import { Box, Grid } from "@mui/material";
import { FieldArray, FormikProps } from "formik";
import { t } from "i18next";
import * as Yup from 'yup';
import { FormType } from "../../../components/Forms/EasyForm";
import EasyFormColumn from "../../../components/Forms/EasyFormColumn";
import { EasyFormRow } from "../../../components/Forms/FormLayout";
import { CreateOrganisationRequest } from "../../../models/Organisation";
import { OrganisationContact, OrganisationContactLabel } from "../../../models/OrganisationContact";
import { getOrganisationContactFields } from "../organisationButtons/details/tabs/ContactsTab";
import { getOrganisationContactValidationScheme } from "../organisationContactSchemeValidation";

export function getOrganisationContactsStepValidation() {
    return Yup.object().shape({
        ceos: Yup.array().of(getOrganisationContactValidationScheme()),
        organisationalManagers: Yup.array().of(getOrganisationContactValidationScheme()),
        securityManagers: Yup.array().of(getOrganisationContactValidationScheme()),
        financialManagers: Yup.array().of(getOrganisationContactValidationScheme()),
        serviceDesks: Yup.array().of(getOrganisationContactValidationScheme())
    })
}

const ContactForm = (props: { fieldName: string, title: string, label: OrganisationContactLabel, getContacts: (organisationRequest: CreateOrganisationRequest) => OrganisationContact[], withoutName?: boolean, formikProps: FormikProps<CreateOrganisationRequest>, formPropsStuf: any }) => {
  const getFields = getOrganisationContactFields(props.withoutName ?? false, true, props.fieldName)
  return (
    <FieldArray
      name={props.fieldName}
      render={arrayHelpers => (

        <EasyFormRow
          confirmDeletionText={t("Are you sure you wish to remove this contact?")}
          {...props.formikProps}
          {...props.formPropsStuf}
          editModeAlways={true}
          editable={true}
          isDeleteable={props.getContacts(props.formikProps.values).length > 1}
          saveMutation={() => { throw "Dont save plz" }}
          formType={FormType.LIST}
          createNew={() => new OrganisationContact(props.label)}
          editMode={true}
          getFieldRows={(organisationRequest: CreateOrganisationRequest) => getFields(props.getContacts(organisationRequest))}
          columns={[
            new EasyFormColumn(props.title, "", []),
          ]}
          arrayHelpers={arrayHelpers} />

      )}
    />
  )
}

export default function OrganisationContactsStep(props: { formikProps: FormikProps<CreateOrganisationRequest>, formPropsStuf: any }) {
  return (
    <Box>
      <Grid container rowSpacing={3} columnSpacing={9}>
        <Grid item xs={6}>
          <ContactForm fieldName="ceos" label={OrganisationContactLabel.CEO} title="Overall contact / CEO" getContacts={(request: CreateOrganisationRequest) => request.ceos} key="ceos" formikProps={props.formikProps} formPropsStuf={props.formPropsStuf} />
        </Grid>
        <Grid item xs={6}>
          <ContactForm fieldName="securityManagers" label={OrganisationContactLabel.SECURITY_MANAGER} title="Security manager" getContacts={(request: CreateOrganisationRequest) => request.securityManagers} formikProps={props.formikProps} formPropsStuf={props.formPropsStuf} />
        </Grid>
        <Grid item xs={6}>
          <ContactForm fieldName="organisationalManagers" label={OrganisationContactLabel.ORGANISATIONAL_MANAGER} title="Organisational manager" getContacts={(request: CreateOrganisationRequest) => request.organisationalManagers} formikProps={props.formikProps} formPropsStuf={props.formPropsStuf} />
        </Grid>
        <Grid item xs={6}>
          <ContactForm fieldName="financialManagers" label={OrganisationContactLabel.FINANCIAL_MANAGER} title="Financial manager" getContacts={(request: CreateOrganisationRequest) => request.financialManagers} formikProps={props.formikProps} formPropsStuf={props.formPropsStuf} />
        </Grid>
        <Grid item xs={6}>
          <ContactForm fieldName="serviceDesks" label={OrganisationContactLabel.SERVICE_DESK} title="Service desk and on-call" getContacts={(request: CreateOrganisationRequest) => request.serviceDesks} withoutName formikProps={props.formikProps} formPropsStuf={props.formPropsStuf} />
        </Grid>
      </Grid>
    </Box>
  )
}